import { inject, Injectable } from "@angular/core";
import { Translation, TranslocoLoader } from "@jsverse/transloco";
import { HttpClient } from "@angular/common/http";

// Timestamp de la dernière modification de l'index.html (reconstruit à chaque ng build).
// Permet d'éviter le cache navigateur sur les fichiers de traduction JSON après un déploiement.
const BUILD_VERSION = new Date(document.lastModified).getTime();

@Injectable({ providedIn: 'root' })
export class TranslocoHttpLoader implements TranslocoLoader {
    private http = inject(HttpClient);

    getTranslation(lang: string) {
        return this.http.get<Translation>(`/assets/i18n/${lang}.json?v=${BUILD_VERSION}`);
    }
}
